import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';

const PublicRoute = ({ children }) => {
  const { isAuth, loading } = useAuthContext();
  const location = useLocation();

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (isAuth) {
    // Se já está autenticado, redirecionar para onde estava tentando ir ou dashboard
    const from = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  return children;
};

export default PublicRoute;
